import { stringify } from 'qs';

import { api } from 'helper/api';
import { formatUsername } from 'helper/form';
import { Auth } from 'models/auth';

export function getTokens(username: string, password: string): Promise<Auth> {
  const formData = { grant_type: 'password', password, username: formatUsername(username) };
  return api.build().withBasicAuth()
    .post('/oauth/token', stringify(formData));
}

export function refreshTokens(refreshToken: string): Promise<Auth> {
  const formData = { grant_type: 'refresh_token', refresh_token: refreshToken };
  return api.build().withBasicAuth()
    .post('/oauth/token', stringify(formData));
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/repositories/auth.ts